var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet, Button, MultiColumnList, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { PublisherContactTypeEnum, PublisherLegalFormEnum, } from "../../types/Api";
import { fetchRegions } from "../../api/regionService";
import { FieldRow } from "../FieldRow";
import { AccordionSection } from "../AccordionSection";
import { ExpandCollapseToggle } from "../ExpandCollapseToggle";
import { formatDate } from "../../utils/formatUtils";
import { PublisherPrefixHistoryTable } from "../PublisherPrefixHistoryTable";
import { usePublisherPrefixHistoryData } from "../../hooks/usePublisherPrefixHistoryData";
import { usePermissions } from "../../hooks/usePermissions";
import { navigation } from "../navigation";
var ENFORCEMENT_QUICK_JUMPS = [
    {
        navigationKey: "titlesWithIsbn",
        labelId: "ui-br-legaldeposits.publishers.button.titlesWithIsbn",
    },
    {
        navigationKey: "titlesWithoutIsbn",
        labelId: "ui-br-legaldeposits.publishers.button.titlesWithoutIsbn",
    },
    {
        navigationKey: "periodicalsManagement",
        labelId: "ui-br-legaldeposits.publishers.button.periodicals",
    },
];
var PublisherDetail = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var publisher = _a.publisher;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var history = useHistory();
    var hasAnyRole = usePermissions().hasAnyRole;
    var regionsData = useQuery(["regions"], function () {
        return fetchRegions(ky);
    }).data;
    var _j = usePublisherPrefixHistoryData(publisher.id), prefixHistoryData = _j.prefixHistoryData, isPrefixHistoryLoading = _j.isLoading;
    var regionName = (_c = (_b = regionsData === null || regionsData === void 0 ? void 0 : regionsData.items) === null || _b === void 0 ? void 0 : _b.find(function (region) { return region.id === publisher.regionId; })) === null || _c === void 0 ? void 0 : _c.name;
    var mainAddress = publisher.mainAddress;
    var mailingAddress = publisher.mailingAddress;
    var hasMailingAddress = !!(((_d = publisher.mailingAddress) === null || _d === void 0 ? void 0 : _d.street) ||
        ((_e = publisher.mailingAddress) === null || _e === void 0 ? void 0 : _e.postalCode) ||
        ((_f = publisher.mailingAddress) === null || _f === void 0 ? void 0 : _f.municipality));
    var _k = useState({
        enforcement: true,
        general: true,
        address: true,
        contacts: true,
        prefixHistory: true,
    }), accordionStatus = _k[0], setAccordionStatus = _k[1];
    var _l = useState(true), expandAll = _l[0], setExpandAll = _l[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var allowedQuickJumps = ENFORCEMENT_QUICK_JUMPS.map(function (_a) {
        var navigationKey = _a.navigationKey, labelId = _a.labelId;
        return ({
            labelId: labelId,
            path: navigation[navigationKey].path,
            roles: navigation[navigationKey].roles,
        });
    }).filter(function (_a) {
        var roles = _a.roles;
        return !roles || hasAnyRole(roles);
    });
    var openWithPublisherFilter = function (path) {
        var _a;
        // publisherId is the only param on purpose - "Sprava periodik" queries
        // libraryStatus=SUBSCRIBED unconditionally (useSubscribedPeriodicalsData),
        // so a libraryStatus in the URL would change nothing there.
        history.push({
            pathname: path,
            search: "?publisherId=".concat(encodeURIComponent((_a = publisher.id) !== null && _a !== void 0 ? _a : "")),
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                enforcement: false,
                general: false,
                address: false,
                contacts: false,
                prefixHistory: false,
            });
        }
        else {
            setAccordionStatus({
                enforcement: true,
                general: true,
                address: true,
                contacts: true,
                prefixHistory: true,
            });
        }
        setExpandAll(!expandAll);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.detail.pane.title" })),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        React.createElement(AccordionSet, null,
            !!publisher.id && allowedQuickJumps.length > 0 && (React.createElement(AccordionSection, { id: "enforcement", labelId: "ui-br-legaldeposits.publishers.accordion.enforcement", open: accordionStatus.enforcement, onToggle: function () { return toggleAccordion("enforcement"); } },
                React.createElement(Row, null, allowedQuickJumps.map(function (_a) {
                    var labelId = _a.labelId, path = _a.path;
                    return (React.createElement(Col, { key: path, xs: 12, md: 4 },
                        React.createElement(Button, { fullWidth: true, marginBottom0: true, onClick: function () { return openWithPublisherFilter(path); } },
                            React.createElement(FormattedMessage, { id: labelId }))));
                })))),
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-legaldeposits.publishers.accordion.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.name", value: publisher.name }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.nameSuffix", value: publisher.nameSuffix })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.qualifier", value: publisher.qualifier }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.legalForm", value: publisher.legalForm === PublisherLegalFormEnum.LEGAL
                                ? formatMessage({
                                    id: "ui-br-legaldeposits.publishers.field.legalForm.legal",
                                })
                                : formatMessage({
                                    id: "ui-br-legaldeposits.publishers.field.legalForm.natural",
                                }) })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.owner", value: formatMessage({
                                id: "ui-br-legaldeposits.publishers.owner.".concat(publisher.owner),
                            }) })),
                    React.createElement(Col, { xs: 12, md: 6 }, publisher.companyNumber ? (React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.companyNumber", value: publisher.companyNumber })) : (React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.birthDate", value: publisher.birthDate ? formatDate(publisher.birthDate) : "" }))),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.field.region", value: regionName !== null && regionName !== void 0 ? regionName : "" })))),
            React.createElement(AccordionSection, { id: "address", labelId: "ui-br-legaldeposits.publishers.accordion.address", open: accordionStatus.address, onToggle: function () { return toggleAccordion("address"); } },
                React.createElement("h4", null,
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.address.mainAddress.name" })),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 4 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.address.mainAddress.field.street", value: mainAddress === null || mainAddress === void 0 ? void 0 : mainAddress.street })),
                    React.createElement(Col, { xs: 12, md: 4 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.address.mainAddress.field.postalCode", value: mainAddress === null || mainAddress === void 0 ? void 0 : mainAddress.postalCode })),
                    React.createElement(Col, { xs: 12, md: 4 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.address.mainAddress.field.municipality", value: mainAddress === null || mainAddress === void 0 ? void 0 : mainAddress.municipality }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.address.mainAddress.field.region", value: (_g = mainAddress === null || mainAddress === void 0 ? void 0 : mainAddress.region) === null || _g === void 0 ? void 0 : _g.name }))),
                hasMailingAddress && (React.createElement(React.Fragment, null,
                    React.createElement("h4", null,
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.address.mailingAddress.name" })),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, md: 4 },
                            React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.address.mailingAddress.field.street", value: mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress.street })),
                        React.createElement(Col, { xs: 12, md: 4 },
                            React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.address.mailingAddress.field.postalCode", value: mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress.postalCode })),
                        React.createElement(Col, { xs: 12, md: 4 },
                            React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.address.mailingAddress.field.municipality", value: mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress.municipality }))),
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, md: 6 },
                            React.createElement(FieldRow, { labelId: "ui-br-legaldeposits.publishers.address.mailingAddress.field.region", value: (_h = mailingAddress === null || mailingAddress === void 0 ? void 0 : mailingAddress.region) === null || _h === void 0 ? void 0 : _h.name })))))),
            React.createElement(AccordionSection, { id: "contacts", labelId: "ui-br-legaldeposits.publishers.accordion.contacts", open: accordionStatus.contacts, onToggle: function () { return toggleAccordion("contacts"); } }, !publisher.contacts || publisher.contacts.length === 0 ? (React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("div", null, formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.contacts.empty",
                    }))))) : (React.createElement(MultiColumnList, { contentData: publisher.contacts.map(function (contact) { return ({
                    type: formatMessage({
                        id: "ui-br-legaldeposits.publishers.contact.".concat(contact.type),
                    }),
                    value: contact.type === PublisherContactTypeEnum.WEB ? (React.createElement("a", { href: contact.value, target: "_blank", rel: "noopener noreferrer" }, contact.value)) : (contact.value),
                    source: formatMessage({
                        id: "ui-br-legaldeposits.publishers.contactSource.".concat(contact.source || "LEGAL_DEPOSITS"),
                    }),
                    info: contact.info,
                    isPrimary: contact.isPrimary
                        ? formatMessage({
                            id: "ui-br-legaldeposits.publishers.contact.primary",
                        })
                        : "",
                }); }), visibleColumns: ["type", "value", "source", "info", "isPrimary"], columnMapping: {
                    type: formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.contacts.type",
                    }),
                    value: formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.contacts.value",
                    }),
                    source: formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.contacts.source",
                    }),
                    info: formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.contacts.info",
                    }),
                    isPrimary: "",
                }, interactive: false }))),
            React.createElement(AccordionSection, { id: "prefixHistory", labelId: "ui-br-legaldeposits.publishers.accordion.prefixHistory", open: accordionStatus.prefixHistory, onToggle: function () { return toggleAccordion("prefixHistory"); } },
                React.createElement(PublisherPrefixHistoryTable, { prefixes: prefixHistoryData, isLoading: isPrefixHistoryLoading })))));
};
export default PublisherDetail;
